import React, {useCallback, useMemo, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import Prev from "../../assets/image/icon_prev.svg";
import useFetch from "@common/hooks/fetch/useFetch";
import {getThemeList} from "@common/services/restapi/theme";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";

function ThemeAdList () {
  const history = useHistory();

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  const searchQuery = useMemo(() => {
    return {
      pageNumber: 1,
      pageSize: 12,
      isSummary: true
    }
  }, [])

  const {data: themeList} = useFetch(() => getThemeList(searchQuery), [searchQuery], {});

  console.log(themeList)

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">테마 광고</h3>
      </div>

      <div className="theme-list">
        <div className="thumbnail-wrap playlist">
          {
            themeList.recommendAds && themeList.recommendAds.map((theme, index) => {
              return (
                <a href={convertPath(`/recommend/theme/${theme.id}`)} className="thumbnail-list playlist" key={`theme-${index}`}>
                  <div className="left-box">
                    <LazyLoadImage className="thumbnail-card theme" src={`${theme.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                    <div className="text-box">
                      <h4 className="ad-title">{theme.title}</h4>
                      <div className="ad-subtitle">광고 <span>{theme.totalCount}</span>개</div>
                    </div>
                  </div>
                </a>
              )
            })
          }
        </div>
      </div>
    </>
  )
}

export default ThemeAdList
